export const environment = {
	production: true,
	backend: '/',
}
